import { render, staticRenderFns } from "./Datenschutz.vue?vue&type=template&id=892d7e68&scoped=true"
import script from "./Datenschutz.vue?vue&type=script&lang=ts"
export * from "./Datenschutz.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "892d7e68",
  null
  
)

export default component.exports